/**
 * Course ID Alias System
 * Maps database course IDs to static file course IDs for cases where they differ
 * 
 * Phase 5: Provides forward compatibility for ID mismatches
 */

export const COURSE_ID_ALIASES: Record<string, string> = {
  // Database ID -> Static ID (for cases where they differ)
  'machine-learning-intro': 'ml-fundamentals',
};

/**
 * Resolves a course ID to its canonical alias (if one exists)
 */
export const resolveCourseId = (id: string): string => {
  return COURSE_ID_ALIASES[id] || id;
};

/**
 * Gets all aliases for a course (including the original ID)
 * Useful for searching across both DB and static representations
 */
export const getAllAliasesForCourse = (id: string): string[] => {
  const aliases = [id];
  
  // Add reverse lookup
  for (const [dbId, staticId] of Object.entries(COURSE_ID_ALIASES)) {
    if (dbId === id) aliases.push(staticId);
    if (staticId === id) aliases.push(dbId);
  }
  
  return [...new Set(aliases)];
};

/**
 * Checks if two course IDs refer to the same course (considering aliases)
 */
export const isSameCourse = (id1: string, id2: string): boolean => {
  const aliases1 = getAllAliasesForCourse(id1);
  return aliases1.includes(id2);
};
